var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("客户管理")]),
              ]),
              _vm.isChange == 0
                ? _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { path: "/myCustomers" } } },
                    [_c("div", { staticClass: "div3" }, [_vm._v("我的客户")])]
                  )
                : _vm._e(),
              _c(
                "el-breadcrumb-item",
                {
                  attrs: {
                    to: {
                      name: "customerInformation",
                      query: { id: this.customerId },
                    },
                  },
                },
                [_c("div", { staticClass: "div3" }, [_vm._v("客户资料")])]
              ),
              _vm.isChange == 0
                ? _c(
                    "el-breadcrumb-item",
                    {
                      attrs: {
                        to: {
                          name: "add_order",
                          query: {
                            userId: this.customerId,
                            pingZ: this.pingZ,
                            receivedMoney: this.receivedMoney,
                            total: this.total,
                            userIntention: this.form.userIntention,
                            userDitch: this.form.userDitch,
                            channelOrderId: this.channelOrderId,
                          },
                        },
                      },
                    },
                    [_c("div", { staticClass: "div3" }, [_vm._v("添加订单")])]
                  )
                : _vm._e(),
              _vm.isChange == 1 && !_vm.$route.query.isCommit
                ? _c(
                    "el-breadcrumb-item",
                    {
                      attrs: {
                        to: {
                          name: "fixOrder",
                          query: {
                            customerId: this.customerId,
                            taskId: this.taskId,
                            addressId: this.addressId,
                            total: this.total,
                            orderId: this.orderId,
                            receivedMoney: this.receivedMoney,
                            userIntention: this.form.userIntention,
                            userDitch: this.form.userDitch,
                          },
                        },
                      },
                    },
                    [_c("div", { staticClass: "div3" }, [_vm._v("修改订单")])]
                  )
                : _vm._e(),
              _vm.isChange == 1 && _vm.$route.query.isCommit == 2
                ? _c(
                    "el-breadcrumb-item",
                    {
                      attrs: {
                        to: {
                          name: "wyUpdate",
                          query: {
                            customerId: this.customerId,
                            taskId: this.taskId,
                            addressId: this.addressId,
                            total: this.total,
                            orderId: this.orderId,
                            receivedMoney: this.receivedMoney,
                            userIntention: this.form.userIntention,
                            userDitch: this.form.userDitch,
                          },
                        },
                      },
                    },
                    [_c("div", { staticClass: "div3" }, [_vm._v("修改订单")])]
                  )
                : _vm._e(),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("审核订单")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._m(0),
      _c(
        "div",
        { staticClass: "step" },
        [
          _c(
            "el-steps",
            { attrs: { active: 2, "align-center": "" } },
            _vm._l(_vm.stepsData.list, function (item) {
              return _c("el-step", { attrs: { title: item } })
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "basic" },
        [
          _c("el-collapse-transition", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.show3,
                    expression: "!show3",
                  },
                ],
                staticClass: "content",
              },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      inline: true,
                      model: _vm.form,
                      "label-width": "80px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "入线方式" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "选择入线方式",
                              clearable: "",
                              filterable: "",
                              disabled: "",
                            },
                            model: {
                              value: _vm.form.Incoming,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "Incoming", $$v)
                              },
                              expression: "form.Incoming",
                            },
                          },
                          _vm._l(_vm.line, function (items) {
                            return _c("el-option", {
                              key: items.id,
                              attrs: { label: items.name, value: items.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "入线时间" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            placeholder: "选择入线时间",
                            type: "date",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd",
                            disabled: "",
                          },
                          model: {
                            value: _vm.form.ditchTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "ditchTime", $$v)
                            },
                            expression: "form.ditchTime",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "购买次数" } },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "请输入客户购买次数",
                            disabled: "",
                          },
                          model: {
                            value: _vm.form.buyNumber,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "buyNumber", $$v)
                            },
                            expression: "form.buyNumber",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "客户意向" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "选择客户意向" },
                            model: {
                              value: _vm.form.intention,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "intention", $$v)
                              },
                              expression: "form.intention",
                            },
                          },
                          _vm._l(_vm.intention, function (items) {
                            return _c("el-option", {
                              key: items.dictId,
                              attrs: {
                                label: items.dictName,
                                value: items.dictId,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "客户等级" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "选择客户等级",
                              disabled: "",
                            },
                            model: {
                              value: _vm.form.category,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "category", $$v)
                              },
                              expression: "form.category",
                            },
                          },
                          _vm._l(_vm.rank, function (items) {
                            return _c("el-option", {
                              key: items.id,
                              attrs: { label: items.name, value: items.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "客户姓名" } },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "请输入客户姓名",
                            disabled: "",
                          },
                          model: {
                            value: _vm.form.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "name", $$v)
                            },
                            expression: "form.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "客户性别" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "选择性别", disabled: "" },
                            model: {
                              value: _vm.form.sex,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "sex", $$v)
                              },
                              expression: "form.sex",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "男", value: "1" },
                            }),
                            _c("el-option", {
                              attrs: { label: "女", value: "2" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "客户年龄" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "number",
                            placeholder: "请输入客户年龄",
                            disabled: "",
                          },
                          model: {
                            value: _vm.form.age,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "age", $$v)
                            },
                            expression: "form.age",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "联系电话" } },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "请输入客户电话",
                            disabled: "",
                          },
                          model: {
                            value: _vm.form.phone1,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "phone1", $$v)
                            },
                            expression: "form.phone1",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "联系二" } },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "请输入客户电话",
                            disabled: "",
                          },
                          model: {
                            value: _vm.form.phone2,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "phone2", $$v)
                            },
                            expression: "form.phone2",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "receipt" }, [
        _vm._m(1),
        !_vm.temporary
          ? _c(
              "div",
              { staticClass: "determination" },
              [
                _c(
                  "el-form",
                  {
                    ref: "address",
                    attrs: {
                      inline: true,
                      model: _vm.address,
                      "label-width": "100px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "收货人姓名" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入客户姓名" },
                          model: {
                            value: _vm.address.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.address, "name", $$v)
                            },
                            expression: "address.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("el-form-item", { attrs: { label: "联系电话" } }, [
                      _c(
                        "div",
                        { staticClass: "input1" },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入收货电话" },
                            model: {
                              value: _vm.address.phone,
                              callback: function ($$v) {
                                _vm.$set(_vm.address, "phone", $$v)
                              },
                              expression: "address.phone",
                            },
                          }),
                          _c("el-input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.inputIf,
                                expression: "inputIf",
                              },
                            ],
                            attrs: { placeholder: "请输入收货电话2" },
                            model: {
                              value: _vm.address.phone2,
                              callback: function ($$v) {
                                _vm.$set(_vm.address, "phone2", $$v)
                              },
                              expression: "address.phone2",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: "收货地址" } },
                      [
                        _c("levelAddr", {
                          staticClass: "addressContent",
                          attrs: {
                            province: _vm.address.province,
                            city: _vm.address.city,
                            area: _vm.address.area,
                          },
                          on: {
                            updateprovice: _vm.getProvince,
                            updatecity: _vm.getCity,
                            updatearea: _vm.getArea,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "详细地址" } },
                      [
                        _c("el-input", {
                          staticClass: "address",
                          attrs: { placeholder: "请输入客户详细地址" },
                          on: {
                            blur: function ($event) {
                              return _vm.getAddObj()
                            },
                          },
                          nativeOn: {
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.getAddObj()
                            },
                          },
                          model: {
                            value: _vm.address.datail,
                            callback: function ($$v) {
                              _vm.$set(_vm.address, "datail", $$v)
                            },
                            expression: "address.datail",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _vm.alter && _vm.temporary
                          ? _c(
                              "el-button",
                              {
                                attrs: { size: "mini" },
                                on: {
                                  click: function ($event) {
                                    _vm.temporary = true
                                  },
                                },
                              },
                              [_vm._v("取消")]
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: { click: _vm.add_Addresss },
                          },
                          [_vm._v("新增到地址库")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.alter && _vm.temporary
          ? _c("div", { staticClass: "submitAddress" }, [
              _c(
                "p",
                [
                  _c(
                    "svg",
                    {
                      staticClass: "icon",
                      attrs: {
                        t: "1610611479340",
                        viewBox: "0 0 1024 1024",
                        version: "1.1",
                        xmlns: "http://www.w3.org/2000/svg",
                        "p-id": "21176",
                        width: "22",
                        height: "22",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M896 832c-32-57.6-70.4-96-140.8-115.2-44.8-12.8-89.6-38.4-128-70.4-32-25.6-38.4-44.8-12.8-83.2 32-51.2 64-108.8 70.4-172.8 12.8-96-6.4-217.6-140.8-256-25.6 0-44.8-6.4-76.8 6.4-134.4 51.2-147.2 192-115.2 313.6 12.8 44.8 38.4 83.2 64 115.2 19.2 32 12.8 51.2-12.8 70.4-38.4 38.4-83.2 64-134.4 76.8-64 19.2-108.8 57.6-140.8 115.2-12.8 51.2 6.4 64 57.6 64 217.6-6.4 428.8-6.4 646.4 0 51.2-6.4 70.4-19.2 64-64z",
                          fill: "#cdcdcd",
                          "p-id": "21177",
                        },
                      }),
                    ]
                  ),
                  _c("span", [_vm._v(_vm._s(_vm.referaddress.userName))]),
                  _c(
                    "svg",
                    {
                      staticClass: "icon",
                      attrs: {
                        t: "1610611642756",
                        viewBox: "0 0 1024 1024",
                        version: "1.1",
                        xmlns: "http://www.w3.org/2000/svg",
                        "p-id": "22555",
                        width: "22",
                        height: "22",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M587.491556 646.485333l19.512888-11.776c7.623111-4.494222 13.937778-7.850667 20.195556-10.581333 44.316444-19.626667 83.342222-5.745778 134.940444 52.906667 31.971556 36.295111 41.415111 68.551111 29.070223 97.28-9.159111 21.390222-26.851556 36.181333-58.368 54.499555-2.048 1.137778-20.195556 11.377778-24.860445 14.222222-73.329778 43.975111-241.379556-56.718222-362.268444-228.864-121.173333-172.544-152.576-356.522667-78.279111-401.180444l9.841777-6.030222 10.638223-6.712889c37.546667-23.665778 61.610667-33.109333 90.112-28.444445 28.501333 4.778667 52.736 25.258667 73.216 62.577778 43.235556 78.961778 33.678222 116.394667-21.902223 150.414222-3.982222 2.503111-18.204444 10.808889-19.512888 11.662223-13.653333 8.192 9.443556 63.146667 63.089777 139.491555 54.272 77.198222 99.669333 119.466667 114.517334 110.535111z",
                          fill: "#cdcdcd",
                          "p-id": "22556",
                        },
                      }),
                    ]
                  ),
                  _c("span", [_vm._v(" " + _vm._s(_vm.referaddress.phone))]),
                  _c(
                    "svg",
                    {
                      staticClass: "icon",
                      attrs: {
                        t: "1610611888850",
                        viewBox: "0 0 1024 1024",
                        version: "1.1",
                        xmlns: "http://www.w3.org/2000/svg",
                        "p-id": "28154",
                        width: "23",
                        height: "23",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M512 187.847111c-149.276444 0-270.279111 121.742222-270.279111 271.928889 0 75.036444 30.264889 142.961778 79.132444 192.227556L512 844.231111l191.146667-192.284444a271.872 271.872 0 0 0 79.132444-192.284445c0-150.186667-121.002667-271.872-270.279111-271.872z m0 392.704A120.490667 120.490667 0 0 1 391.850667 459.662222 120.433778 120.433778 0 0 1 512 338.887111a120.490667 120.490667 0 0 1 120.149333 120.888889A120.433778 120.433778 0 0 1 512 580.551111z",
                          fill: "#cdcdcd",
                          "p-id": "28155",
                        },
                      }),
                    ]
                  ),
                  _c("span", [_vm._v(" " + _vm._s(_vm.referaddress.address))]),
                  _c("span", [
                    _vm._v(" " + _vm._s(_vm.referaddress.detailedAddress)),
                  ]),
                  _vm.referaddress.isDefault == 1
                    ? _c(
                        "el-tag",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { type: "primary", size: "mini" },
                        },
                        [_vm._v("默认收货地址")]
                      )
                    : _vm._e(),
                  _vm.referaddress.userName
                    ? _c(
                        "el-tag",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { type: "danger", size: "mini" },
                          on: {
                            click: function ($event) {
                              return _vm.addressHiddenEvent(_vm.referaddress)
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("p", { staticClass: "lingshi" }, [
                _c(
                  "span",
                  {
                    on: {
                      click: function ($event) {
                        _vm.alter = false
                        _vm.temporary = true
                      },
                    },
                  },
                  [_vm._v("更改")]
                ),
                _c(
                  "span",
                  {
                    on: {
                      click: function ($event) {
                        _vm.temporary = false
                      },
                    },
                  },
                  [_vm._v("使用临时地址")]
                ),
              ]),
            ])
          : _vm._e(),
        !_vm.alter && _vm.temporary
          ? _c(
              "div",
              { staticClass: "addList" },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.radioAddress,
                      callback: function ($$v) {
                        _vm.radioAddress = $$v
                      },
                      expression: "radioAddress",
                    },
                  },
                  _vm._l(_vm.hereContent, function (items) {
                    return _c(
                      "div",
                      {
                        key: items.id,
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                          "align-items": "center",
                          padding: "10px 0",
                          "border-bottom": "1px solid #d9d9d9",
                        },
                      },
                      [
                        _c(
                          "el-radio",
                          {
                            attrs: { label: items.id },
                            on: {
                              change: function ($event) {
                                return _vm.useAddress(items)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "radioCont" }, [
                              _c(
                                "div",
                                [
                                  _c("span", [_vm._v(_vm._s(items.userName))]),
                                  _c("span", [
                                    _vm._v(" " + _vm._s(items.phone)),
                                  ]),
                                  _c("span", [
                                    _vm._v(" " + _vm._s(items.address)),
                                  ]),
                                  _c("span", [
                                    _vm._v(" " + _vm._s(items.detailedAddress)),
                                  ]),
                                  items.isDefault == 1
                                    ? _c(
                                        "el-tag",
                                        {
                                          staticStyle: {
                                            "margin-left": "10px",
                                          },
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                          },
                                        },
                                        [_vm._v("默认收货地址")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "p",
                          {
                            staticStyle: {
                              width: "80px",
                              "text-align": "center",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.addressHiddenEvent(items)
                              },
                            },
                          },
                          [_vm._v(" 编辑 ")]
                        ),
                      ],
                      1
                    )
                  }),
                  0
                ),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-top": "10px" },
                    attrs: { size: "mini" },
                    on: {
                      click: function ($event) {
                        _vm.alter = true
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c("div", { staticClass: "orderBox" }, [
        _c(
          "div",
          { staticClass: "order" },
          [
            _c(
              "p",
              {
                staticClass: "header",
                staticStyle: { background: "#fff", padding: "10px" },
              },
              [_vm._v("订单商品")]
            ),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "商品名称" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_c("p", [_vm._v(_vm._s(scope.row.title))])]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "商品数量" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "numer" }, [
                            _c("span", [_vm._v(_vm._s(scope.row.number))]),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "商品单价" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_c("p", [_vm._v(_vm._s(scope.row.sellPrice))])]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "brandId", label: "商品品牌" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "typeId", label: "商品分类" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "specificationName", label: "商品规格" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "total", label: "商品小计" },
                }),
              ],
              1
            ),
            _c(
              "el-table",
              { staticStyle: { width: "100%" }, attrs: { data: _vm.tableZp } },
              [
                _c("el-table-column", {
                  attrs: { label: "赠品名称" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_c("p", [_vm._v(_vm._s(scope.row.title))])]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "赠品数量" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "numer" }, [
                            _c("span", [_vm._v(_vm._s(scope.row.number))]),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "赠品单价" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_c("p", [_vm._v(_vm._s(scope.row.sellPrice))])]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "brandId", label: "赠品品牌" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "categoryId", label: "赠品分类" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "specificationName", label: "赠品规格" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "total", label: "赠品小计" },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "page1" }, [
          _c("p", [
            _c("span", [
              _vm._v("总计：共 " + _vm._s(_vm.orderNumber) + " 件 "),
            ]),
          ]),
          _vm._m(2),
          _c("p", [
            _c("span", [
              _vm._v("赠品总价："),
              !_vm.is_null(_vm.giftPrice)
                ? _c("span", [_vm._v(_vm._s(_vm.giftPrice))])
                : _vm._e(),
              _vm.is_null(_vm.giftPrice) ? _c("span", [_vm._v("0")]) : _vm._e(),
              _vm._v(" 元"),
            ]),
          ]),
          _c(
            "p",
            [
              _c("span", [_vm._v("总价:")]),
              _c("el-input", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.total,
                  callback: function ($$v) {
                    _vm.total = $$v
                  },
                  expression: "total",
                },
              }),
            ],
            1
          ),
          _c(
            "p",
            [
              _c("span", [_vm._v("已收款:")]),
              _c("el-input", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.receivedMoney,
                  callback: function ($$v) {
                    _vm.receivedMoney = $$v
                  },
                  expression: "receivedMoney",
                },
              }),
            ],
            1
          ),
          _c("p", [
            _c("span", { staticStyle: { color: "#999" } }, [
              _vm._v("原总价：" + _vm._s(_vm.origTotal)),
            ]),
          ]),
          _vm.parArray.indexOf("jlSign") != -1 &&
          _vm.position != "manager" &&
          !_vm.$route.query.isCommit
            ? _c(
                "p",
                [
                  _c("span", [_vm._v("经理签字：")]),
                  _c(
                    "el-radio-group",
                    {
                      staticStyle: { "margin-top": "3px" },
                      attrs: { disabled: _vm.isManagerDefault },
                      model: {
                        value: _vm.isManager,
                        callback: function ($$v) {
                          _vm.isManager = $$v
                        },
                        expression: "isManager",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.isChange == 0
            ? _c(
                "p",
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "30px" },
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.toReviewOrder()
                        },
                      },
                    },
                    [_vm._v("提交订单")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.isChange == 1
            ? _c(
                "p",
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "30px" },
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.trueOrderTips },
                    },
                    [_vm._v("确定提交")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _c("div", { staticClass: "orderNotes" }, [
        _vm._m(3),
        _c(
          "div",
          { staticClass: "notes" },
          [
            _c("el-input", {
              attrs: { type: "textarea", disabled: "", placeholder: "备注" },
              model: {
                value: _vm.textarea,
                callback: function ($$v) {
                  _vm.textarea = $$v
                },
                expression: "textarea",
              },
            }),
            _vm._l(_vm.fileList, function (item, index) {
              return _c("p", { key: index }, [
                !_vm.is_null(_vm.fileList)
                  ? _c("img", {
                      directives: [
                        { name: "image-preview", rawName: "v-image-preview" },
                      ],
                      staticClass: "avatar",
                      attrs: { src: _vm.ImgHttps + item.img },
                    })
                  : _vm._e(),
              ])
            }),
          ],
          2
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.addressHidden,
            "append-to-body": true,
            title: "编辑地址",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addressHidden = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "address",
              attrs: {
                "label-position": "right",
                model: _vm.addressDialog,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "收货人姓名" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入客户姓名" },
                    model: {
                      value: _vm.addressDialog.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.addressDialog, "name", $$v)
                      },
                      expression: "addressDialog.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "联系电话" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入收货电话" },
                    model: {
                      value: _vm.addressDialog.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.addressDialog, "phone", $$v)
                      },
                      expression: "addressDialog.phone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "收货地址" } },
                [
                  _c("levelAddr", {
                    staticClass: "addressContent",
                    attrs: {
                      province: _vm.addressDialog.province,
                      city: _vm.addressDialog.city,
                      area: _vm.addressDialog.area,
                    },
                    on: {
                      updateprovice: _vm.getProvince1,
                      updatecity: _vm.getCity1,
                      updatearea: _vm.getArea1,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "详细地址" } },
                [
                  _c("el-input", {
                    staticClass: "address",
                    attrs: { placeholder: "请输入客户详细地址" },
                    on: {
                      blur: function ($event) {
                        return _vm.getAddObj1()
                      },
                    },
                    nativeOn: {
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.getAddObj1()
                      },
                    },
                    model: {
                      value: _vm.addressDialog.datail,
                      callback: function ($$v) {
                        _vm.$set(_vm.addressDialog, "datail", $$v)
                      },
                      expression: "addressDialog.datail",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { "true-label": 1, "false-label": 0 },
                          model: {
                            value: _vm.addressDialog.isDefault,
                            callback: function ($$v) {
                              _vm.$set(_vm.addressDialog, "isDefault", $$v)
                            },
                            expression: "addressDialog.isDefault",
                          },
                        },
                        [_vm._v("默认收获地址")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.editSussess()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.addressHidden = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content page-title" }, [
      _c("h2", [_vm._v("提交订单")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header" }, [
      _c("span", [_vm._v("选择收货地址")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("span", [_vm._v("运费：0 ")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header" }, [
      _c("span", [_vm._v("订单备注")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }